import { render, staticRenderFns } from "./13MedalManagement.vue?vue&type=template&id=64034f91&scoped=true&"
import script from "./13MedalManagement.vue?vue&type=script&lang=js&"
export * from "./13MedalManagement.vue?vue&type=script&lang=js&"
import style0 from "./13MedalManagement.vue?vue&type=style&index=0&id=64034f91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64034f91",
  null
  
)

export default component.exports